// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QcEzwFgrwuARJeNkQ72C {
    margin-bottom: 4px;
    margin-top: 8px;
    text-align: left;
    font-size: 16px;
}

.yhQ93TZBWjkYaEp8eRSw input {
    opacity: 0;
    width: 0;
    height: 0;
}

.yhQ93TZBWjkYaEp8eRSw {
    width: 100%;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
    cursor: pointer;
    transition: .3s;
}

.yhQ93TZBWjkYaEp8eRSw:hover {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.yhQ93TZBWjkYaEp8eRSw:first-child  {
    border-radius: 5px 0 0 5px;
}

.yhQ93TZBWjkYaEp8eRSw:last-child {
    border-radius: 0 5px 5px 0;
}

.tl8cD4F2sm3UGLXh8SLT, .tEfkCwNhTwyBWW2s6jtA.yhQ93TZBWjkYaEp8eRSw.tl8cD4F2sm3UGLXh8SLT, .tEfkCwNhTwyBWW2s6jtA.yhQ93TZBWjkYaEp8eRSw.tl8cD4F2sm3UGLXh8SLT:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    color: white;
}

.tl8cD4F2sm3UGLXh8SLT:hover {
    color: white;
}

.ehu0rh875QOS0IEclmhi {
    display: flex;
    width: 100%;
}

.tEfkCwNhTwyBWW2s6jtA.yhQ93TZBWjkYaEp8eRSw{
    background-color: #F1F1F4;
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
    color: rgb(84, 84, 84);
}

.tEfkCwNhTwyBWW2s6jtA.yhQ93TZBWjkYaEp8eRSw:hover {
    background-color: #F1F1F4;
    color: rgb(84, 84, 84);
}
`, "",{"version":3,"sources":["webpack://./src/components/library/InputRadioList/InputRadioList.module.css"],"names":[],"mappings":"AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8DAAkC;IAClC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,0DAA0B;IAC1B,mDAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,8DAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,0DAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B","sourcesContent":["@value colors: \"../style/colors.css\";\n@value color-purple, color-gray-light, color-gray from colors;\n\n.label {\n    margin-bottom: 4px;\n    margin-top: 8px;\n    text-align: left;\n    font-size: 16px;\n}\n\n.select input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.select {\n    width: 100%;\n    height: 42px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid color-gray-light;\n    cursor: pointer;\n    transition: .3s;\n}\n\n.select:hover {\n    border-color: color-purple;\n    color: color-purple;\n}\n\n.select:first-child  {\n    border-radius: 5px 0 0 5px;\n}\n\n.select:last-child {\n    border-radius: 0 5px 5px 0;\n}\n\n.checked, .disabled.select.checked, .disabled.select.checked:hover {\n    background-color: color-purple;\n    color: white;\n}\n\n.checked:hover {\n    color: white;\n}\n\n.list {\n    display: flex;\n    width: 100%;\n}\n\n.disabled.select{\n    background-color: #F1F1F4;\n    border-color: color-gray;\n    color: rgb(84, 84, 84);\n}\n\n.disabled.select:hover {\n    background-color: #F1F1F4;\n    color: rgb(84, 84, 84);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"label": `QcEzwFgrwuARJeNkQ72C`,
	"select": `yhQ93TZBWjkYaEp8eRSw`,
	"checked": `tl8cD4F2sm3UGLXh8SLT`,
	"disabled": `tEfkCwNhTwyBWW2s6jtA`,
	"list": `ehu0rh875QOS0IEclmhi`
};
export default ___CSS_LOADER_EXPORT___;
